"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseCreditKarmaUtmContent = exports.CKOfferBadge = exports.CKHomeOwnershipType = exports.CKStatedUsageType = exports.CKUtmContentField = void 0;
/**
 * Defines the UTM Content fields for Credit Karma that we parse
 * from the URL params.
 * @TranslateToPython @TranslateToEnum
 */
var CKUtmContentField;
(function (CKUtmContentField) {
    CKUtmContentField["lbi"] = "lbi";
    CKUtmContentField["lbterm"] = "lbterm";
    CKUtmContentField["lbamount"] = "lbamount";
    CKUtmContentField["lbapr"] = "lbapr";
    CKUtmContentField["lbown"] = "lbown";
    CKUtmContentField["lbhp"] = "lbhp";
    CKUtmContentField["lblp"] = "lblp";
    CKUtmContentField["model"] = "model";
    CKUtmContentField["approvingmodelid"] = "approvingmodelid";
})(CKUtmContentField || (exports.CKUtmContentField = CKUtmContentField = {}));
/**
 * Defines the Stated Usage Fields for Credit Karma that we parse
 * from the URL params.
 * @TranslateToPython @TranslateToEnum
 */
var CKStatedUsageType;
(function (CKStatedUsageType) {
    CKStatedUsageType["REFI_CC"] = "REFI_CC";
    CKStatedUsageType["CONSOLIDATE_DEBT"] = "CONSOLIDATE_DEBT";
    CKStatedUsageType["HOME_IMPROVEMENT"] = "HOME_IMPROVEMENT";
    CKStatedUsageType["MAJOR_PURCHASE"] = "MAJOR_PURCHASE";
    CKStatedUsageType["COVER_UNEXPECTED_COST"] = "COVER_UNEXPECTED_COST";
    CKStatedUsageType["OTHER"] = "OTHER";
})(CKStatedUsageType || (exports.CKStatedUsageType = CKStatedUsageType = {}));
/**
 * Defines the Home Ownership Fields for Credit Karma that we parse
 * from the URL params.
 * @TranslateToPython @TranslateToEnum
 */
var CKHomeOwnershipType;
(function (CKHomeOwnershipType) {
    CKHomeOwnershipType["OWN"] = "OWN";
    CKHomeOwnershipType["RENT"] = "RENT";
})(CKHomeOwnershipType || (exports.CKHomeOwnershipType = CKHomeOwnershipType = {}));
var CKOfferBadge;
(function (CKOfferBadge) {
    CKOfferBadge["OUTSTANDING"] = "OUTSTANDING";
    CKOfferBadge["EXCELLENT"] = "EXCELLENT";
    CKOfferBadge["LIGHTBOX_EVERYWHERE"] = "LIGHTBOX_EVERYWHERE";
})(CKOfferBadge || (exports.CKOfferBadge = CKOfferBadge = {}));
const parseCreditKarmaUtmContent = (utmContent) => {
    if (utmContent === '') {
        return {
            [CKUtmContentField.lbi]: undefined,
            [CKUtmContentField.lbterm]: undefined,
            [CKUtmContentField.lbamount]: undefined,
            [CKUtmContentField.lbapr]: undefined,
            [CKUtmContentField.lbown]: undefined,
            [CKUtmContentField.lbhp]: undefined,
            [CKUtmContentField.lblp]: undefined,
            [CKUtmContentField.model]: undefined,
            [CKUtmContentField.approvingmodelid]: undefined,
        };
    }
    const parts = utmContent.split('_');
    // Remove the brackets from each part if they exist
    // Trim each part and convert to uppercase
    const cleanedParts = parts
        .map((part) => part.replace(/^\[|\]$/g, ''))
        .map((part) => part.trim())
        .map((part) => part.toUpperCase());
    // Map to expected fields
    return {
        [CKUtmContentField.lbi]: cleanedParts[0] ?? undefined,
        [CKUtmContentField.lbterm]: cleanedParts[1] ?? undefined,
        [CKUtmContentField.lbamount]: cleanedParts[2] ?? undefined,
        [CKUtmContentField.lbapr]: cleanedParts[3] ?? undefined,
        [CKUtmContentField.lbown]: cleanedParts[4] ?? undefined,
        [CKUtmContentField.lbhp]: cleanedParts[5] ?? undefined,
        [CKUtmContentField.lblp]: cleanedParts[6] ?? undefined,
        [CKUtmContentField.model]: cleanedParts[7] ?? undefined,
        [CKUtmContentField.approvingmodelid]: cleanedParts[8] ?? undefined,
    };
};
exports.parseCreditKarmaUtmContent = parseCreditKarmaUtmContent;
